import { render } from "./SidebarMenuItemCatalog.vue?vue&type=template&id=9812a18a&scoped=true"
import script from "./SidebarMenuItemCatalog.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemCatalog.vue?vue&type=script&lang=js"

import "./SidebarMenuItemCatalog.vue?vue&type=style&index=0&id=9812a18a&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9812a18a"]])

export default __exports__